import _ from 'lodash'
import m from 'moment'
import { compose, withProps } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const allMomentsQuery = gql`
  query AllMoments($userId: ID!) {
    allMoments(orderBy: momentAt_DESC, filter: { user: { id: $userId } }) {
      id
      momentAt
      message
    }
  }
`

export const withMomentDays = compose(
  graphql(allMomentsQuery),
  withProps(({ data }) => ({
    isLoading: data.isLoading,
    momentDays: toMomentDay(data.allMoments),
  })),
)

function toMomentDay(moments = []) {
  return _.groupBy(moments, moment => m(moment.momentAt).format('YYYY-MM-DD'))
}



// WEBPACK FOOTER //
// ./src/components/templates/moment/withMomentDays.js